import React from "react"

import {QuickSearchResultProps} from "./@type"
import TaskTypeIcon from "../../../../../../core/gd-components/icons/task-icon/task-icon-ui5"

export default function QuickSearch_ResultTask(props: QuickSearchResultProps) {

    const task = props.searchResult.item;
    const project   = gd.session.projects.get(task.projectId)

    const classes = Classes("row ui5-list-item", props.className, {
        'selected': props.searchResult.index === props.quickSearch.keyboardIterator.currentIndex
    });

    return (
        <div className={classes} onClick={props.searchResult.onClick}>
            <div className="cell">
                <div className="title">
                    <div className="icon-22 m-r-10">
                        <TaskTypeIcon taskTypeId={task.taskTypeId} />
                    </div>
                    {task.shortId && <span className="short-id m-r-10">#{task.shortId}</span>}
                    <div className="ui5-txt-default max-w-250">{task.title}</div>
                </div>
            </div>
            <div className="cell align-r">
                <div className="ui5-property max-w-200">{project?.name}</div>
            </div>
        </div>
    );
}